export default __webpack_public_path__ + "static/media/logo_icon.05e89c02.svg";